import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AddContactInfoRequest } from '@/types/entities/contactInfo';
import { AddAddressRequest } from '@/domains/addresses/types/api/requests/AddAddressRequest';
import { DeleteInsuredRequest } from '../types/api/requests/DeleteInsuredRequest';

const insuredSlice = createSlice({
  name: 'insureds',
  initialState: {},
  reducers: {
    addInsuredAddress: (_, _action: PayloadAction<AddAddressRequest>) => {},
    addInsuredContactInfo: (_, _action: PayloadAction<AddContactInfoRequest>) => {},
    deleteInsured: (_, _action: PayloadAction<DeleteInsuredRequest>) => {},
    deleteInsuredSuccess: () => {},
  },
});

export const { addInsuredAddress, addInsuredContactInfo, deleteInsured, deleteInsuredSuccess } = insuredSlice.actions;

export const insuredsReducer = insuredSlice.reducer;
export const insuredsReducerPath = insuredSlice.reducerPath;
